import { render } from "./DeleteBuyInModal.vue?vue&type=template&id=8faffa76&scoped=true"
import script from "./DeleteBuyInModal.vue?vue&type=script&lang=js"
export * from "./DeleteBuyInModal.vue?vue&type=script&lang=js"

import "./DeleteBuyInModal.vue?vue&type=style&index=0&id=8faffa76&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8faffa76"]])

export default __exports__